import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  forwardRef, Input,
  QueryList,
  Output,
  EventEmitter
} from '@angular/core';
import { TabComponent } from './tab/tab.component';
import { CounterStyle, Style } from 'src/app/models/common.enums';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less']
})
export class TabsComponent implements AfterViewInit {
  @ContentChildren(forwardRef(() => TabComponent)) tabs: QueryList<TabComponent>;

  @Input() activeTabId: string | number;
  @Input() tabStyle: string = Style.default;
  @Input() counterStyle: string = CounterStyle.default;
  @Input() hasContent: boolean = true;
  
  @Output() tabChanged = new EventEmitter<string | number>();

  readonly counterStyleEnum = CounterStyle;
  readonly tabStyleEnum = Style;

  constructor(private cdRef: ChangeDetectorRef) { }

  ngAfterViewInit() {
    if (!this.tabs.some(i => i.active)) {
      this.selectTab(this.tabs.first.id);
      this.cdRef.detectChanges();
    }
  }

  selectTab(id: string | number) {
    this.activeTabId = id;
    this.tabs.forEach(i => {
      i.active = i.id === id;
    });
    this.tabChanged.emit(id)
  }

}
